import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const studentSocialGroupService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-social-group/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching student social group list", error);
            throw error;
        }
    },

    async findByStudentUuid(studentUuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/student-social-group/findByStudentUuid/${studentUuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findById student social group", error);
            throw error;
        }
    },

    async create(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-social-group/create`,
                paramsCopy
            );
            return response.data;
        } catch (error) {
            console.error("Error create student social group", error);
            throw error;
        }
    },

    async save(socialGroup: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/student-social-group/save`,
                socialGroup
            );
            return response.data;
        } catch (error) {
            console.error("Error save student social group", error);
            throw error;
        }
    },

    async deleteById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/student-social-group/deleteById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById student social group", error);
            throw error;
        }
    }
}

export default studentSocialGroupService;